import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "process-reports" }
const _hoisted_2 = { class: "process-reports__select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_ElOption = _resolveComponent("ElOption")!
  const _component_ElSelect = _resolveComponent("ElSelect")!
  const _component_DemographicCharts = _resolveComponent("DemographicCharts")!
  const _component_RequestProcessesModal = _resolveComponent("RequestProcessesModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`chartsDashboard.select[1]`)), 1),
        (_ctx.showProcessTooltip)
          ? (_openBlock(), _createBlock(_component_ElTooltip, {
              key: 0,
              placement: "top",
              enterable: false,
              "popper-class": "process-reports__tooltip-popper el-abaca-tooltip"
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.tooltipText), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_PxIcon, {
                  size: 17,
                  name: "question"
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ElSelect, {
          modelValue: _ctx.selectedProcessUid,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProcessUid) = $event)),
          filterable: "",
          "default-first-option": "",
          "popper-class": "process-reports__select-list",
          disabled: _ctx.selectDisabled
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userProcesses, (option) => {
              return (_openBlock(), _createBlock(_component_ElOption, {
                key: option.uid,
                value: option.uid,
                label: option.title
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      "element-loading-background": "#fafafa",
      class: _normalizeClass(["process-reports__content", {
        'process-reports__loading': _ctx.loading,
      }])
    }, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_DemographicCharts, {
              theme: _ctx.theme,
              "process-reports-data": _ctx.data,
              view: _ctx.view
            }, null, 8, ["theme", "process-reports-data", "view"]),
            (_ctx.showEmptyState)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_RequestProcessesModal, {
                    visibility: _ctx.showEmptyState,
                    "onUpdate:visibility": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showEmptyState) = $event))
                  }, null, 8, ["visibility"]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "process-reports__overlay" }, null, -1))
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 2)), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}